'use strict';

var base = require('@pixi-spine/base');

class BoneData {
  constructor(index, name, parent) {
    this.x = 0;
    this.y = 0;
    this.rotation = 0;
    this.scaleX = 1;
    this.scaleY = 1;
    this.shearX = 0;
    this.shearY = 0;
    this.transformMode = base.TransformMode.Normal;
    this.skinRequired = false;
    this.color = new base.Color();
    if (index < 0)
      throw new Error("index must be >= 0.");
    if (name == null)
      throw new Error("name cannot be null.");
    this.index = index;
    this.name = name;
    this.parent = parent;
  }
}

exports.BoneData = BoneData;
//# sourceMappingURL=BoneData.js.map
